import React from 'react'

import styles from './Input.module.css'

const Select = ({ label, value, options, onChange, className, disabled }) => {
  return (
    <div
      className={`${styles.container} ${className || styles.defaultContainer}`}
    >
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={styles.input}
      >
        {options.map((option, i) => (
          <option value={option.value} key={i}>
            {option.label}
          </option>
        ))}
      </select>
      {label && <label>{label}</label>}
    </div>
  )
}

export default Select
